import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, InputAdornment, Box } from '@mui/material';
import { BusinessOutlined } from '@mui/icons-material';
import { usePMDetailsEditor } from '../../../../hooks/usePMDetailsEditor';
import { useGetCentersQuery } from '../../../../../../services/DimensionService/dimensionApi';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const PMCenterEditor: React.FC<Props> = ({ mode }) => {
  const { pmDetails, updatePMField, updateAsset } = usePMDetailsEditor(mode);
  const { data: centers = [], isLoading } = useGetCentersQuery();
  const labelId = `${mode}-pm-center-label`;

  const handleChange = (value: string) => {
    updatePMField({ centerId: value });
    // Clear asset selection when center changes
    updateAsset({ assetId: '', assetTag: '', assetName: '' });
  };

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth required>
        <InputLabel id={labelId}>Center</InputLabel>
        <Select
          labelId={labelId}
          value={pmDetails?.centerId || ''}
          onChange={(e) => handleChange(e.target.value)}
          label="Center"
          disabled={isLoading}
          startAdornment={
            <InputAdornment position="start">
              <BusinessOutlined sx={{ color: '#64748b', fontSize: 18 }} />
            </InputAdornment>
          }
        >
          {centers.map((center) => (
            <MenuItem key={center.value} value={center.value}>
              {center.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PMCenterEditor;
